import gql from 'graphql-tag';

export default gql`
  query NotificationCount {
    notificationCount {
      count_number
    }
  }
`;